import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


// PrimeNG DatePicker (range) value lifecycle: null → [start] → [start, end].
// We validate so the Save button stays disabled until BOTH dates are chosen,
// and also ensure end >= start via dateRangeCompleteValidator.
// If you only need “both dates picked” (no order check), you could use:
// [Validators.required, Validators.minLength(2)] instead.
export const dateRangeCompleteValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const v = control.value;
  if (v == null) return { required: true };
  if (!Array.isArray(v)) return { rangeInvalid: true };

  const [start, end] = v;
  if (!start || !end) return { rangeIncomplete: true };

  const s = new Date(start);
  const e = new Date(end);
  if (isNaN(s.getTime()) || isNaN(e.getTime())) return { rangeInvalid: true };
  if (e < s) return { rangeOrder: true };

  return null;
};